import styled from 'styled-components';

export const TabledRowText = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: space-between;
`;
